import { z } from 'zod';

const RoleSchema = z.object({
  when: z.string(),
  where: z.string(),
  role: z.string(),
  company: z.string(),
  desc: z.string(),
});

const EducationSchema = z.object({
  deg: z.string(),
  school: z.string(),
  years: z.string(),
  note: z.string().optional(),
});

export const ExperienceSchema = z.object({
  roles: z.array(RoleSchema).min(1),
  skills: z.array(z.tuple([z.string(), z.array(z.string())])).min(1),
  education: z.array(EducationSchema).min(1),
  recognition: z.array(z.string()).min(1),
});

export type Role = z.infer<typeof RoleSchema>;
export type Education = z.infer<typeof EducationSchema>;
export type Experience = z.infer<typeof ExperienceSchema>;
